import React, { Component } from 'react';
import BaseComponent from '../base/BaseComponent';
import { getCurrentUser } from '../utils';
import { Modal, Radio, Input, Icon } from "antd"
import UploadWall from '../components/upload/UploadWall';
import { message } from '../view/sysManagement/utils/sysManagementUtils';
import { validateName } from '../utils';
import { connect } from 'react-redux';
import {
    changeLoginStatus, changeNavigateStauts,
    getInfoFromLocalStorage,
    loadCurrentUser, loadNavigateData,
    loadSystemConfigList,
    shrinNavigateStauts, updataNavigateData,
    updateNavigateLevel2Data
} from './../actions';
import {PIC_TYPE, PIC_TYPE_ORIGINAL} from '../constants';
import './Profile.css'
import {setInfoToLocalStorage} from "../actions";
import {refreshToken} from "../base/request";

const accept = PIC_TYPE_ORIGINAL.map(item=>("."+item)).join(",")

class Profile extends BaseComponent {
    constructor(props) {
        super(props)
        this.state = {
            user: {},
            loading: false,
        }
    }

    componentDidMount() {
        const id = getCurrentUser().id;
        this.queryUserByConditionRequest(id);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.visible && prevProps.visible !== this.props.visible) {
            const id = getCurrentUser().id
            this.queryUserByConditionRequest(id)
        }
    }

    render() {
        const { user, loading } = this.state
        const {visible} = this.props;

        if (!user.photoUrl || user.photoUrl === 'images/header_girls.png' || user.photoUrl === 'images/header_boys.png') {
            if (user.sex === 2) {
                user.photoUrl = 'images/header_girls.png'
            } else {
                user.photoUrl = 'images/header_boys.png'
            }
        }
        return <Modal
            title="个人信息"
            visible={visible}
            okText="确认"
            cancelText="取消"
            width={520}
            onOk={this.onOk}
            onCancel={this.onCancel}
            destroyOnClose={true}
        >
            <ul className='profile-list' style={{padding:0}}>
                <li className='profile-header'>
                    <div className='header-img'>
                        <div style={{ display: loading ? "" : "none" }} className='loading-wrap'>
                            <Icon type="loading" />
                        </div>
                        <img className='photo-img' src={user.photoUrl} alt="" style={{objectFit: 'cover'}} />
                    </div>
                    <UploadWall
                        style={{ width: "auto", marginTop: 20 }}
                        accept={accept}
                        beforeUpload={this.handleBeforeUpload}
                        multiple={false}
                        action="/dynamic/storage/uploadFile"
                        showUploadBtn={true}
                        listType="list"
                        uploadBtnName="更换头像"
                        onChange={this.handleChange}
                    />
                </li>
                <li className="profile-item">
                    <div className='item-label'>
                        账号：
                    </div>
                    <div className='item-value'>
                        {user.account}
                    </div>
                </li>
                <li className="profile-item">
                    <div className='item-label'>
                        姓名：
                    </div>
                    <div className='item-value'>
                        <Input onChange={e => {
                            const { user } = this.state;
                            // let a=window.currentUser;
                            // console.log('-------',a);
                            this.setState({
                                user: { ...user, name: e.target.value }
                            })
                        }}
                            value={user.name}
                            placeholder="请输入用户姓名"
                        />
                    </div>
                </li>
                <li className="profile-item">
                    <div className='item-label'>
                        部门：
                    </div>
                    <div className='item-value'>
                        {
                            user.deptList && user.deptList.length ?
                                user.deptList.map(item => item.name).join("、")
                                : null
                        }
                    </div>
                </li>
                <li className="profile-item">
                    <div className='item-label'>
                        角色：
                    </div>
                    <div className='item-value'>
                        {
                            user.roleList && user.roleList.length ?
                                user.roleList.map(item => item.roleName).join("、")
                                : null
                        }
                    </div>
                </li>
                <li className="profile-item">
                    <div className='item-label'>
                        性别：
                    </div>
                    <div className='item-value'>
                        <Radio.Group onChange={e => {
                            const { user } = this.state;
                            this.setState({
                                user: { ...user, sex: e.target.value }
                            },()=>{
                                console.log('e.target.value--------------',this.state.user)
                            })
                        }} value={user.sex}>
                            <Radio value={1}>男</Radio>
                            <Radio value={2}>女</Radio>
                        </Radio.Group>
                    </div>
                </li>
                <li className="profile-item">
                    <div className='item-label'>
                        手机：
                    </div>
                    <div className='item-value'>
                        <Input onChange={e => {
                            const { user } = this.state
                            this.setState({
                                user: { ...user, phone: e.target.value }
                            })
                        }} value={user.phone}
                            placeholder="请输入手机号"
                        />
                    </div>
                </li>
                <li className="profile-item">
                    <div className='item-label'>
                        办公电话：
                    </div>
                    <div className='item-value'>
                        <Input onChange={e => {
                            const { user } = this.state
                            this.setState({
                                user: { ...user, tel: e.target.value }
                            })
                        }} value={user.tel}
                            placeholder="请输入办公电话"
                        />
                    </div>
                </li>
            </ul>
        </Modal>
    }
    //上传前添加上传提示，限制非格式的上传
    handleBeforeUpload = (file, fileList) => {
        let fileName = file.name.split('.');
        let upload = fileName.at(-1).toUpperCase();
        upload = PIC_TYPE.includes(upload);
        if(!upload){
            message.error('暂不支持该文件类型!');
        }
        return new Promise((resolve, reject) => {
            if (!upload) {
                reject(file);
            } else {
                resolve(file);
            }
        });
    };
    onOk = () => {
        const { user } = this.state;
        if (!user.phone) {
            delete user.phone
        }
        if (!user.tel) {
            delete user.tel
        }
        // console.log('user=======================',user);
        user&&user.deptList&&user.deptList.map(item=>{
            item.deptId=item.id;
            if(user&&user.roleCodes){
                item.roleCodes=user.roleCodes
            }
        });
        user.deptRoles=user.deptList;
        this.updateUserRequest(user, res => {
            if (res) {
                setInfoToLocalStorage("currentUser", user);
                // 刷新当前 token 和reftoken
                refreshToken(()=>{
                    this.props.loadCurrentUser()
                })
                message.success('操作成功');
                this.onCancel();
            }
        })
    };

    onCancel = () => {
        this.props.onCancel()
    };
    // 个人资料校验
    updateUserRequest = ({ id, account, name, deptRoles, sex, photoUrl, tel, phone } = {}, callBack) => {
        name = name.trim();
        let telRegexp = new RegExp("^[0][0-9]{2,3}-[0-9]{5,10}$");
        let telRegexp_1 = new RegExp("^[0-9]{3}-[0-9]{3}-[0-9]{4}$");
        let telRegexp_ = new RegExp("^[1-9]{1}[0-9]{5,8}$");
        let phoneRegexp = new RegExp("^[1][0-9][0-9]{9}$");
        if (!name) {
            message.error("姓名不能为空！");
            return false;
        }
        if (!validateName(name, { min: 1, max: 50 })) {
            message.error("姓名为1-50个字符,可使用中文、数字、字母、下划线！");
            return false;
        }
        if (tel && tel.length > 0 && !telRegexp.test(tel) && !telRegexp_.test(tel) && !telRegexp_1.test(tel)) {
            message.error("办公电话格式不正确！");
            return;
        }
        if (phone && phone.length > 0 && !phoneRegexp.test(phone)) {
            message.error("手机格式不正确！");
            return;
        }

        this.request({
            url: "/cm-sites-sys/user/updateUserData",
            method: "post",
            contentType: "json",
            body: {
                id,
                account,
                name,
                sex,
                photoUrl,
                tel,
                phone
            },
            callBack
        });
    };

    getUserById = (id, callBack) => {
        this.request({
            url: "/cm-sites-sys/user/getUserById?id=" + id,
            callBack: res => {
                console.log(res)
                this.setState({
                    user: res
                })
            }
        })
    }

    handleChange = info => {
        const { user } = this.state
        if (info.file.status === 'uploading') {
            this.setState({ loading: true });
            return;
        }
        // console.log('++++++++++++++++++++++++++++',info,info.file);
        if (info.file.status === 'done') {
            this.setState({
                user: {
                    ...user,
                    photoUrl: info.file.response.data.smallPath
                },
                loading: false,
            })
        }
    };

    queryUserByConditionRequest = (id, callBack) => {
        let {currentUser} = this.getInfo();
        if(currentUser && currentUser.account) {
            let deptList = currentUser.defaultInfo && currentUser.defaultInfo.dept || {};
            let roleList = currentUser.defaultInfo && currentUser.defaultInfo.roleList || [];
            currentUser={
                ...currentUser,
                deptList:[deptList],
                roleList:[...roleList],
            };
            this.setState({
                user: currentUser
            })
        } else {
            this.request({
                url: "/cm-sites-sys/user/conditionQuery",
                method: "post",
                body: { ids: [id] },
                contentType: "json",
                callBack: res => {
                    if (res.data.length) {
                        this.setState({
                            user: res.data[0]
                        })
                    }
                }
            });
        }
    };

}

function mapStateToProps(state) {
    return {
        currentUser: state.systemReducer.currentUser,
    }
}
export default connect(mapStateToProps, { loadCurrentUser })(Profile)
